<template>
  <div>
    <base-header :style="{ background: '#F7F8FD' }" class="py-6">
      <div class="row"></div>
    </base-header>

    <div class="container-fluid">
      <v-app>
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-6">
              <h2 class="m-0">Shop Report</h2>
            </div>
            <div class="col-6 d-flex justify-content-end">
              <download-excel
                :data="filteredData"
                :fields="filteredHeaders"
                title="Shop Report"
              >
                <base-button
                  icon="fa fa-file-excel"
                  class="border-0 text-white bg-dark"
                  style="backgroundcolor: black"
                  size="md"
                >
                </base-button>
              </download-excel>
            </div>
          </div>

          <div class="row align-items-center">
            <div class="col-md">
              <v-autocomplete
                deletable-chips
                :menu-props="{
                  closeOnClick: true,
                  closeOnContentClick: true,
                }"
                small-chips
                return-object
                label="Shop"
                v-model="searchData.shop"
                item-text="name"
                :items="shopList"
              ></v-autocomplete>
            </div>
            <div class="col-md">
              <v-autocomplete
                deletable-chips
                multiple
                :menu-props="{
                  closeOnClick: true,
                  closeOnContentClick: true,
                }"
                small-chips
                return-object
                clearable
                item-text="name"
                v-model="searchData.products"
                label="Products"
                :items="productList"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index < maxDisplay" @click="data.select">
                    {{ item.name }} &nbsp;
                  </v-chip>

                  <span v-if="index === maxDisplay" class="grey--text caption"
                    >(+{{
                      searchData.products.length - maxDisplay
                    }}
                    products)</span
                  >
                </template>
                <v-list-tile
                  class="row-pointer p-3"
                  slot="prepend-item"
                  ripple
                  @click="toggleProductSelect"
                >
                  <v-list-tile-action class="mr-2">
                    <v-icon
                      :color="
                        searchData.products.length > 0 ? 'indigo darken-4' : ''
                      "
                      >{{ iconProduct }}</v-icon
                    >
                  </v-list-tile-action>
                  <v-list-tile-title class="ml-5 mt-3"
                    >Select All</v-list-tile-title
                  >
                </v-list-tile>
                <v-divider slot="prepend-item" class="mt-2"
              /></v-autocomplete>
            </div>
          </div>
          <div class="row mt-0 mt-md-4">
            <div class="col-md mt-0 mt-md-3">
              <v-text-field
                class="mt-0 mt-md-4"
                label="Start Date"
                type="date"
                v-model="searchData.from_date"
                fab
              ></v-text-field>
            </div>
            <div class="col-md mt-0 mt-md-3">
              <v-text-field
                class="mt-0 mt-md-4"
                label="End Date"
                type="date"
                v-model="searchData.to_date"
                fab
              ></v-text-field>
            </div>
            <div class="col-md">
              <label class="form-control-label">Apply filters</label>
              <base-button
                type="test"
                @click="filterReport"
                class="w-100"
                outline
                >Search</base-button
              >
            </div>
            <div class="col-md mt-4 mt-md-0">
              <label class="form-control-label">Clear filters</label>
              <base-button type="base" class="w-100" outline>Clear</base-button>
            </div>
          </div>

          <div v-if="data.length > 0" class="table-responsive mt-4">
            <base-table
              class="align-items-center"
              thead-classes="thead-light"
              type="hover"
              :data="data"
            >
              <template slot="columns">
                <th>Sl</th>
                <th v-for="(header, index) in headers" :key="index">
                  {{ header }}
                </th>
              </template>
              <template slot-scope="{ row, index }">
                <td>{{ index + 1 }}</td>
                <td>{{ row.user.username }}</td>
                <td>{{ row.shop.name }}</td>
                <td>{{ row.shop.place }}</td>
                <td>{{ row.date }}</td>
                <td v-for="(header, idx) in prodHeaders" :key="idx">
                  {{ data[index][header] }}
                </td>
                <td>{{ row.amount }}</td>
              </template>
            </base-table>
          </div>
          <div v-else class="d-flex justify-content-center">
            <lottie-player
              src="https://assets1.lottiefiles.com/packages/lf20_lwnuxmxm.json"
              background="transparent"
              speed="1"
              style="width: 300px; height: 300px"
              loop
              autoplay
            ></lottie-player>
          </div>
        </card>
      </v-app>
    </div>
  </div>
</template>
<script>
export default {
  name: "shop-report",
  data() {
    return {
      tableHeaders: ["Staff", "Date", "Shop Name", "ShopLocation"],
      pagedTableData: [],
      maxDisplay: 2,
      searchData: {
        shop: null,
        products: [],
        from_date: null,
        to_date: null,
      },
      headers: ["Staff", "Date", "Shop Name", "ShopLocation"],
      data: [],
      filteredData: [],
      filteredHeaders: [],
    };
  },
  methods: {
    filterReport() {
      console.log(this.searchData);
      let products = this.searchData.products.map((item) => item.id);

      let error = undefined;

      if (this.searchData.shop === null) {
        error = "Please select a shop";
      }

      if (this.searchData.from_date === "") {
        this.searchData.from_date = null;
      }

      if (this.searchData.to_date === "") {
        this.searchData.to_date = null;
      }

      let payload = {};

      if (
        this.searchData.from_date === null ||
        this.searchData.to_date === null
      ) {
        payload = {
          shop: this.searchData.shop?.id,
          products: products,
        };
      } else {
        payload = {
          shop: this.searchData.shop?.id,
          products: products,
          from_date: this.searchData.from_date,
          to_date: this.searchData.to_date,
        };
      }

      if (error) {
        this.$notify({
          title: error,
          icon: "fa fa-exclamation-triangle",
          type: "danger",
        });
      } else {
        console.log(payload);

        this.$store
          .dispatch("fetchShopReport", {
            payload,
          })
          .catch((err) => {
            this.$notify({
              title: "Failed to fetch shop report",
              icon: "fa fa-exclamation-triangle",
              type: "danger",
              message: err.toString(),
            });
          });
      }
    },
    fetchProductList() {
      this.$store.dispatch("fetchProductList").catch((err) => {
        this.$notify({
          title: "Failed to fetch products list",
          icon: "fa fa-exclamation-triangle",
          type: "danger",
          message: err.toString(),
        });
      });
    },
    fetchAllShopList() {
      this.$store.dispatch("fetchAllShopList").catch((err) => {
        this.$notify({
          title: "Failed to fetch shop list",
          icon: "fa fa-exclamation-triangle",
          type: "danger",
          message: err.toString(),
        });
      });
    },
    toggleProductSelect() {
      this.$nextTick(() => {
        if (this.selectAllProduct) {
          this.searchData.products = [];
        } else {
          this.searchData.products = this.productList.slice();
        }
      });
    },
  },
  computed: {
    productList() {
      return this.$store.state.productStore.products;
    },
    shopList() {
      return this.$store.state.staffStore.allShops;
    },
    shopReport() {
      return this.$store.state.reportStore.shopReport;
    },
    selectAllProduct() {
      return this.searchData.products.length === this.productList.length;
    },
    selectSomeProduct() {
      return this.searchData.products.length > 0 && !this.selectAllProduct;
    },
    iconProduct() {
      if (this.selectAllProduct) return "mdi-close-box";
      if (this.selectSomeProduct) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  watch: {
    shopReport() {
      let products = [];
      this.shopReport.forEach((item) => {
        item.products.forEach((prod) => products.push(prod.product_name));
      });
      let filteredProd = [...new Set(products)];
      let report = [...this.shopReport];

      filteredProd.forEach((item) => {
        report.forEach((order, idx) => {
          order.products.forEach((prod) => {
            if (prod.product_name === item) {
              let productamount = Number(
                prod.total_price / Number(prod.quantity)
              );
              report[idx][
                prod.product_name
              ] = `${prod.quantity} x ${productamount} = ${prod.total_price}`;
            }
          });
        });
      });
      console.log(filteredProd);
      this.headers = ["Staff", "Shop Name", "Shop Location", "Date"];
      this.headers = [...this.headers, ...filteredProd, "Total Amount"];
      this.prodHeaders = [...filteredProd];
      this.data = [...report];
      let tempdata = [...report];
      tempdata = tempdata.map((item) => ({
        staff: item.user.username,
        shop_name: item.shop.name,
        shop_place: item.shop.place,
        date: item.date,
        ...item,
      }));
      tempdata.forEach((item) => {
        delete item.products;
        delete item.edited_date;
        delete item.gst;
        delete item.id;
        delete item.latitude;
        delete item.longitude;
        delete item.shop;
        delete item.shop_mobile;
        delete item.user;
      });
      this.filteredData = tempdata;
      let data1 = [];
      tempdata.forEach((item) => {
        data1.push(...Object.keys(item));
      });
      let data2 = [...new Set(data1)];
      let data3 = data2.map((e) => [e, e]);
      data3 = Object.fromEntries(data3);
      data3.total_amount = data3.amount;
      delete data3.amount;
      this.filteredHeaders = data3;
    },
  },
  mounted() {
    this.fetchProductList();
    this.fetchAllShopList();
  },
};
</script>
<style>
.row-pointer :hover {
  cursor: pointer;
}
</style>
